import { useLanguage } from "@/LanguageContext";
import { motion } from "framer-motion";

const HANDS_IMG =
  "https://customer-assets.emergentagent.com/job_senior-care-valais/artifacts/56y1yfdy_66e44809-8aea-4160-a8b7-f1f7e0f1267a.jpg";

export default function ProblemSection() {
  const { t } = useLanguage();

  return (
    <section
      data-testid="problem-section"
      className="py-24 lg:py-32 bg-[#F0EBE3] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            <div className="w-full max-w-md mx-auto lg:mx-0 aspect-square rounded-3xl overflow-hidden shadow-lg">
              <img
                src={HANDS_IMG}
                alt="Mains se tenant avec confiance"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
          >
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2C3E50] leading-tight mb-6">
              {t("problem.line1")}
            </h2>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#6FA8B6] leading-tight mb-8">
              {t("problem.line2")}
            </h2>
            <p className="font-body text-base lg:text-lg text-[#2C3E50]/70 leading-relaxed max-w-xl">
              {t("problem.description")}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
